
import React, { Component } from 'react';

class Console extends Component {
    render() {
        return (
            <></>
            // <div className="dev-console">
            //     <button className="dev-console--btn" onClick={() => window.logs = []}>Clear</button>
            //     {window.logs.reverse().map((o, i) => (
            //         <div className="dev-console--item" key={i}>
            //             {JSON.stringify(o)}
            //         </div>
            //     ))}
            // </div>

        );
    }
}

export default Console;